import React, { FC } from 'react';

import { Content } from 'api';
import { PostAction, UserGroup } from 'types/app';
import { ContentProvider } from 'providers';
import { Post, IPostRenderProps } from 'features/posting';

import { getLayout } from '../helpers';

interface IProps {
  content: Content;
  selectedGroup?: UserGroup;
}

const FeedItem: FC<IProps> = props => {
  const { content, selectedGroup } = props;
  const ContentComponent = getLayout(content);

  function renderGroupFeedItem() {
    return (
      <Post action={PostAction.Edit} key={content.content_id} selectedGroup={selectedGroup}>
        {(renderProps: IPostRenderProps) => (
          <ContentComponent selectedGroup={selectedGroup} {...renderProps} />
        )}
      </Post>
    );
  }

  function renderUserFeedItem() {
    return (
      <Post action={PostAction.Edit} key={content.content_id}>
        {(renderProps: IPostRenderProps) => <ContentComponent {...renderProps} />}
      </Post>
    );
  }

  return (
    <ContentProvider value={{ content }}>
      {selectedGroup ? renderGroupFeedItem() : renderUserFeedItem()}
    </ContentProvider>
  );
};

export default FeedItem;
